/**
 * BreakDownWithPlanAction
 *
 * Opens the Plan surface with this epic's own content seeded as the initiative
 * text, so breaking down an epic that already exists starts from what it says
 * rather than a blank prompt (FLOW-614).
 */

import { Component } from "solid-js";
import { useNavigate } from "@solidjs/router";
import { Button } from "../ui/Button";

export interface BreakDownWithPlanActionProps {
  epicId: string;
}

export const BreakDownWithPlanAction: Component<
  BreakDownWithPlanActionProps
> = (props) => {
  const navigate = useNavigate();

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => navigate(`/plan?epic=${encodeURIComponent(props.epicId)}`)}
    >
      Break down with Plan
    </Button>
  );
};

export default BreakDownWithPlanAction;
